import {computed, inject, Injectable, signal} from '@angular/core';
import {ApiService} from "../../../services/api.service";
import {UserService} from "../../../services/user.service";
import {Report} from "../../../shared/interfaces/report";

export type ReportDashboardType = 'daily' | 'weekly'

export interface ReportDashboardData {
  activeReports: Report[],
  solvedReports: Report[],
  ongoingActiveReports: Report[],
  longestReports?: Report[],
  mostCommonReports?: Report[]
}

export interface ReportDashboardRequest {
  type: ReportDashboardType,
  productionLine: string,
}

export interface ReportDashboardResponse {
  dashboardData: ReportDashboardData
}

export interface ReportDashboardState {
  dailyDashboardData: {
    activeReports: Report[],
    solvedReports: Report[],
    ongoingActiveReports: Report[],
  },
  weeklyDashboardData: {
    activeReports: Report[],
    solvedReports: Report[],
    ongoingActiveReports: Report[],
    longestReports: Report[],
    mostCommonReports: Report[]
  }
}

@Injectable({
  providedIn: 'root'
})
export class ReportDashboardService {
  apiService = inject(ApiService);
  userService = inject(UserService);

  private state = signal<ReportDashboardState>({
      dailyDashboardData: {
        activeReports: [],
        solvedReports: [],
        ongoingActiveReports: [],
      },
      weeklyDashboardData: {
        activeReports: [],
        solvedReports: [],
        ongoingActiveReports: [],
        longestReports: [],
        mostCommonReports: []
      }
    }
  )

  vmDaily = computed(() => this.state().dailyDashboardData)
  vmWeekly = computed(() => this.state().weeklyDashboardData)


  constructor() {
  }

  getDailyDashboardData() {
    this.apiService.getDashboardData({
      type: 'daily',
      productionLine: this.userService.userProductionLineId()
    }).subscribe((data) => {
      console.log(data);
      this.state.update((state) => ({
        ...state,
        dailyDashboardData: {
          activeReports: data.dashboardData.activeReports || [],
          solvedReports: data.dashboardData.solvedReports || [],
          ongoingActiveReports: data.dashboardData.ongoingActiveReports || [],
        }
      }))
    })
  }

  getWeeklyDashboardData() {
    this.apiService.getDashboardData({
      type: 'weekly',
      productionLine: this.userService.userProductionLineId()
    }).subscribe((data) => {
      console.log(data);
      this.state.update((state) => ({
        ...state,
        weeklyDashboardData: {
          activeReports: data.dashboardData.activeReports || [],
          solvedReports: data.dashboardData.solvedReports || [],
          ongoingActiveReports: data.dashboardData.ongoingActiveReports || [],
          longestReports: data.dashboardData.longestReports || [],
          mostCommonReports: data.dashboardData.mostCommonReports || [],
        }
      }))
    })
  }
}
